import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  LIBRARY_SALES_TYPE_SET_LIST_SALES,
  LIBRARY_SALES_TYPE_SET_OUTLETS,
  LIBRARY_SALES_TYPE_SET_SALES_DETAIL,
  LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_SET_TOTAL_PAGE,
  LIBRARY_SALES_TYPE_SET_CURRENT_PAGE,
  LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_SET_GRATUITY,
  LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP,
  LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL,
  LIBRARY_SALES_TYPE_SET_DELETED_SALES,
  LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL,
  LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES,
  LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL,
  LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL,
  LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY,
  LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM,
  LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS,
  LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL
} from 'actions/library/salesType/constants'

let initialState = {
  outlets: [],
  salesType: [],
  gratuity: [],
  currentPage: null,
  totalPage: null,
  salesTypeDetail: null,
  deletedSalesType: null,
  showDeleteModal: false,
  showActivatedModal: false,
  openRightColumn: false,
  isSubmittingForm: false,
  mustScrollTop: false,
  activatedSalesType: null,
  enableGratuity: null,
  showSaveToAllOutletsModal: false,
  failedOutlets: null,
  NoGratuityModal: {
    show: false,
    action: null
  }
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case LIBRARY_SALES_TYPE_SET_MUST_SCROLL_TOP:
      return {...state, mustScrollTop: payload.mustScrollTop}
    case LIBRARY_SALES_TYPE_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case LIBRARY_SALES_TYPE_SET_LIST_SALES:
      return {...state, salesType: payload.salesType}
    case LIBRARY_SALES_TYPE_SET_SALES_DETAIL:
      return {...state, salesTypeDetail: payload.salesTypeDetail}
    case LIBRARY_SALES_TYPE_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case LIBRARY_SALES_TYPE_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case LIBRARY_SALES_TYPE_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case LIBRARY_SALES_TYPE_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case LIBRARY_SALES_TYPE_SET_GRATUITY:
      return {...state, gratuity: payload.gratuity}
    case LIBRARY_SALES_TYPE_SET_DELETED_SALES:
      return {...state, deletedSalesType: payload.deletedSalesType}
    case LIBRARY_SALES_TYPE_SHOW_DELETE_MODAL:
      return {...state, showDeleteModal: true}
    case LIBRARY_SALES_TYPE_HIDE_DELETE_MODAL:
      return {...state, showDeleteModal: false}
    case LIBRARY_SALES_TYPE_SET_ACTIVATED_SALES:
      return {...state, activatedSalesType: payload.activatedSalesType}
    case LIBRARY_SALES_TYPE_SHOW_ACTIVATED_MODAL:
      return {...state, showActivatedModal: true}
    case LIBRARY_SALES_TYPE_HIDE_ACTIVATED_MODAL:
      return {...state, showActivatedModal: false}
    case LIBRARY_SALES_TYPE_SHOW_NO_GRATUITY_MODAL:
      return {...state, NoGratuityModal: {show: true, action: payload.action}}
    case LIBRARY_SALES_TYPE_HIDE_NO_GRATUITY_MODAL:
      return {...state, NoGratuityModal: {show: false, action: null}}
    case LIBRARY_SALES_TYPE_SET_STATUS_GRATUITY:
      return {...state, enableGratuity: payload.enableGratuity}
    case LIBRARY_SALES_TYPE_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    case LIBRARY_SALES_TYPE_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return {...state, showSaveToAllOutletsModal: true}
    case LIBRARY_SALES_TYPE_SET_FAILED_OUTLETS:
      return {...state, failedOutlets: payload.failedOutlets}
    case LIBRARY_SALES_TYPE_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return {...state, showSaveToAllOutletsModal: false}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/library/salesType.js